import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import { AssetContext } from '@pages/Asset/Asset.query';
import { getPermissionData } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { useContext } from 'react';
import { Container } from './ResourcesMenu.styles';

const ResourcesMenu = () => {
  const {
    showResources,
    sortResourceByFavorite,
    openAddResource,
    equipmentQuery,
  } = useContext(AssetContext);
  const { role } = useContext(NavigationContext);

  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Resource',
  });

  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);

  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Options"
        itemList={[
          {
            label: 'Add Resource',
            iconName: 'plus',
            disabled: !isEnabled,
            toolTipText: addPermission.message,
            toolTipId: 'addDocumentTooltip',
            disableToolTip: addPermission.allowed,
            onClick: () => {
              if (isEnabled) {
                openAddResource.set(true);
              }
            },
          },
          {
            label: sortResourceByFavorite.get()
              ? 'Remove Sort'
              : 'Sort By: Favorite',
            iconName: 'sort-alphabetical',
            onClick: () => {
              sortResourceByFavorite.set(!sortResourceByFavorite.get());
            },
          },
          {
            label: showResources.get() ? 'Hide Source' : 'Show Source',
            iconName: 'eye-open',
            onClick: () => {
              showResources.set(!showResources.get());
            },
          },
        ]}
      />
    </Container>
  );
};

export { ResourcesMenu };
